// removed by extract-text-webpack-plugin
module.exports = {"shoppingCartItem":"_3SkO0","photo":"ptV0J","nameAndDetails":"_1GcGd","name":"_17i4B","price":"_1Viih","removeButton":"_2S9UM","bullet":"_1bvrH","quantitySelector":"R2c6A","subtotal":"_3gdVq","mobileRemoveButton":"AtSLx"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ShoppingCartItem/index.sass
// module id = 1506
// module chunks = 1